<template>
  <div class="container ancillary-detail-container">
    <div class="base-info">
      <div class="order-base-header aclry-base-header"><strong>订单号:</strong>{{ orderNo || '--' }}</div>
      <div class="order-gray-table-outer aclry-table-outer">
        <table class="order-gray-table">
          <tr>
            <td>
              <span class="_info-t">支付时限：</span>
              <span class="_info-m r">{{ detail.timeLimit || '--' }}</span>
            </td>
          </tr>
          <tr>
            <!--<td>-->
              <!--<span class="_info-t">订单状态：</span>-->
              <!--<span class="_info-m r">{{ detail.statusCn || '&#45;&#45;' }}</span>-->
            <!--</td>-->
            <td>
              <span class="_info-t">订单来源：</span>
              <span class="_info-m">{{ detail.source || '--' }}</span>

            </td>
            <td>
              <span class="_info-t">订单金额：</span>
              <span class="_info-m">{{ detail.orderAmount }}元</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="_info-t">预订日期：</span>
              <span class="_info-m">{{ detail.createTime || '--'}}</span>
            </td>
            <td>
              <span class="_info-t">优惠券抵用：</span>
              <span class="_info-m">{{ detail.totalDeduct }}元</span>
            </td>
            <td>
              <span class="_info-t">已支付金额：</span>
              <span class="_info-m">{{ detail.payAmount }}元</span>
            </td>
            <td>
              <span class="_info-t">未支付金额：</span>
              <span class="_info-m">{{ detail.unPayAmount }}元</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="pass-info">
      <div class="pass-item" v-for="(pass, passIndex) in passengers" :key="passIndex">
        <div class="order-primary-header aclry-primary-header">
          <l8-icon class="l8-icon" type="icon-lvke"/>
          <span class="header-label">旅客{{ passIndex + 1  }}</span>
          <div>
            <span class="header-msg">
              <span>{{ pass.passengerName }}</span>
              <span>{{ getPassTypeCn(pass.passengerType) }}</span>
              <span>{{ pass.certificateTypeCn || '证件号' }} : {{ pass.certificateNo | codeMask({offset: 4, length: 10}) }} </span>
            </span>
          </div>
        </div>
        <div class="ext-order-table-warp">
          <table class="order-default-table ext-order-table">
            <thead>
            <tr>
              <td>序号</td>
              <td>行程</td>
              <td>航班日期</td>
              <td>产品类型</td>
              <td>产品名称</td>
              <td>价格</td>
              <td>数量</td>
              <td>PNR号</td>
              <td>订单状态</td>
              <!-- <td>产品状态</td> -->
              <td>操作</td>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(prod, prodIndex) in pass.details" :key="prodIndex">
                <td>{{ prodIndex + 1 }}</td>
                <td>{{ prod.depAirCn }}-{{ prod.arrAirCn }}</td>
                <td>{{ prod.flightDate }}</td>
                <td>{{ prod.productTypeCn }}</td>
                <td>{{ prod.productName }}</td>
                <td>{{ prod.orderAmount }}元</td>
                <td>{{ '1' }}</td>
                <td>{{ prod.pnrNo }}</td>
                <td>{{ prod.subOrderStatusCn }}</td>
                <!-- <td>{{ prod.orderStatusCn }}</td> -->
                <td>
                  <a class="l8-href" v-if="showRefundSubBtn(prod)" @click="singleCancelHandler(prod)">退订</a>
                  <a class="l8-href" v-else-if="prod.subOrderStatus === 'WP'" @click="singleCancelHandler(prod)">取消</a>
                  <span v-else>--</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="order-action-row">
      <a-button type="primary" v-if="showPayBtn" @click="payHandler">在线支付</a-button>
      <a-button type="default" v-if="showCancelBtn" @click="cancelAllHandler">取消订单</a-button>
      <a-button type="primary" v-if="showRefundBtn" @click="refundAllHandler">退订申请</a-button>
    </div>
    <!--取消弹窗-->
    <a-modal
      title="提示"
      v-model="cancelModVisible"
      wrapClassName="order-modal"
      :okText="'确定'"
      :cancelText="'取消'"
      :closable="false"
      :confirmLoading="cancelConfirmLoading"
      @ok="cancelConfirmHandler"
    >
      确定取消订单？
    </a-modal>
    <!--退票弹窗-->
    <a-modal
      title="提示"
      v-model="refundModVisible"
      wrapClassName="order-modal"
      :okText="'确定'"
      :cancelText="'取消'"
      :closable="false"
      :confirmLoading="refundConfirmLoading"
      @ok="refundConfirmHandler"
    >
      确定退订订单？
    </a-modal>
  </div>
</template>

<script>
import { flatMap, map, filter, countBy } from 'lodash'
import queryString from 'query-string'
import { queryAncillaryDetail, cancelExtProduct } from '@/apis/ancillary'
import { refundExtProduct } from '@/apis/order'

import mixinPayCallBack from '@/components/mixinPayCallback'

import '@/components/l8-icon'
import '@/assets/css/l8-order-common.less'
import './index'
import { userTypeMap } from '@/dicts/member'

const mainSettings = window.__MICRO_ROOT__ ?? {}
const PassTypeCn = {
  'ADT': '身份证',
  'CHD': '有效护照',
  'INF': '军官证'
}

let _mixinPayCallBack = mixinPayCallBack

export default {
  mixins: [_mixinPayCallBack],
  data () {
    return {
      detail: {},
      passengers: {},
      orderNo: '',
      showPayBtn: false,
      showCancelBtn: false,
      showRefundBtn: false,
      // 取消弹窗控制
      cancelModVisible: false,
      cancelConfirmLoading: false,
      // 退订弹窗控制
      refundModVisible: false,
      refundConfirmLoading: false,
      airline: mainSettings.airline,
      userId: ''
    }
  },
  created: function () {
    const query = queryString.parse(location.search)

    if (this.payCallbackParams !== null) {
      let extraParam = this.payCallbackParams
      this.orderNo = extraParam.orderNo
    } else {
      this.orderNo = query.orderNo
    }

    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      if (userTypeMap[userInfo.userType] === 'CARRIER') {
        this.userId = query.outUserId
      }
    }

    this.fetchAncillaryDetail()
  },
  computed: {
    flatProducts: function () {
      let flatProducts = flatMap(this.passengers, (pass) => {
        return map(pass.details, (detail) => {
          return detail
        })
      })

      return flatProducts
    },
    flatProductsNoIti: function () {
      return filter(this.flatProducts, (prod) => (prod.productType !== 'ITINERARY'))
    },
    productCount: function () {
      return countBy(this.flatProducts, (prod) => (prod.subOrderStatus))
    },
    productCountNoIti: function () {
      return countBy(this.flatProductsNoIti, (prod) => (prod.subOrderStatus))
    }
  },
  methods: {
    fetchAncillaryDetail: async function () {
      const { airline, orderNo } = this

      try {
        const res = await queryAncillaryDetail({
          alineCode: airline,
          orderNo
        })

        this.updateAncillaryDetail(res)
      } catch (err) {
        this.$message.error(err.message || '辅营订单详情获取失败，请稍后重试。', () => {
          this.$router.replace({ path: '/ancillary/search' })
        })
      }
    },
    updateAncillaryDetail (detail) {
      this.detail = detail
      this.orderNo = detail.orderNo
      this.passengers = detail.passengers

      this.updateActions(detail.status)
    },
    updateActions (status) {
      if (this.productCount['WP'] > 0) {
        this.showPayBtn = true
        this.showCancelBtn = true
      }

      if (this.productCountNoIti['PF'] > 0) {
        this.showRefundBtn = true
      }

      // 如果可退订的辅营都是不可用的贵宾厅，不显示退订按钮
      if (this.isRestAllDisableHall()) {
        this.showRefundBtn = false
      }

      // 如果可退订的辅营都是行程单，不显示退订按钮
      if (this.isOnlyOneIti()) {
        this.showRefundBtn = false
      }
    },
    payHandler () {
      this.$message.loading('正在跳转支付', 1, () => {
        const query = {
          orderNo: this.orderNo
        }

        if (this.userId) {
          query.outUserId = this.userId
        }

        this.$router.push({
          path: '/extraalone/pay',
          query
        })
      })
    },
    getPassTypeCn (type) {
      return PassTypeCn[type] || '--'
    },
    showRefundSubBtn (prod) {
      if (prod.subOrderStatus === 'PF') {
        if (prod.productType === 'ITINERARY') {
          return false
        } else {
          if (prod.productType === 'VIPHALL' && (['OVERDUE', 'USED'].indexOf(prod.orderStatus) > -1)) {
            return false
          } else {
            return true
          }
        }
      } else {
        return false
      }
    },
    // 取消所有辅营
    cancelAllHandler () {
      let orderIds = flatMap(this.passengers, (pass) => {
        return map(pass.details, (detail) => {
          if (detail.subOrderStatus === 'WP') {
            return detail.id
          } else {
            return ''
          }
        })
      })

      orderIds = filter(orderIds, (id) => (id !== ''))

      this.actionIds = orderIds

      this.cancelModVisible = true
    },
    cancelConfirmHandler () {
      this.cancelAcls()
    },
    async cancelAcls () {
      this.cancelConfirmLoading = true
      const { airline, actionIds } = this

      try {
        await cancelExtProduct({
          airline,
          orderId: this.detail.orderId,
          detailIds: actionIds,
          type: 'OTHER'
        })

        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.success('辅营订单取消成功', () => {
          window.location.reload()
        })
      } catch (err) {
        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.error(err.message || '取消辅营失败，请稍候重试。')
      }
    },
    // 退订所有辅营
    refundAllHandler () {
      let orderIds = flatMap(this.passengers, (pass) => {
        return map(pass.details, (detail) => {
          if (detail.productType !== 'ITINERARY' && detail.subOrderStatus === 'PF') {
            if (detail.productType === 'VIPHALL' && (['OVERDUE', 'USED'].indexOf(detail.orderStatus) > -1)) {
              return ''
            } else {
              return detail.id
            }
          } else {
            return ''
          }
        })
      })

      orderIds = filter(orderIds, (id) => (id !== ''))

      this.actionIds = orderIds

      this.refundModVisible = true
    },
    refundConfirmHandler () {
      this.refundAcls()
    },
    async refundAcls () {
      this.refundConfirmLoading = true

      try {
        await refundExtProduct({
          orderId: this.detail.orderId,
          orderIds: this.actionIds,
          refundType: 'UNCONSTRAINT',
          remark: '',
          type: 'OTHER'
        })

        this.refundConfirmLoading = false
        this.refundModVisible = false
        this.$message.success('辅营订单退订成功，正在刷新订单...', () => {
          window.location.reload()
        })
      } catch (err) {
        this.refundConfirmLoading = false
        this.refundModVisible = false
        this.$message.error(err.message || '取消辅营失败，请稍候重试。')
      }
    },
    // 取消或退订单个辅营
    singleCancelHandler (prod) {
      this.actionIds = [prod.id]

      if (prod.subOrderStatus === 'WP') {
        this.cancelModVisible = true
      } else {
        this.refundModVisible = true
      }
    },
    isOnlyOneIti () {
      if (this.passengers.length === 1) {
        if (this.passengers[0].details.length === 1 && this.passengers[0].details[0].productType === 'ITINERARY') {
          return true
        }
      }
      return false
    },
    isRestAllDisableHall () {
      let hallDisable = filter(this.flatProducts, (prod) => {
        if (prod.productType === 'VIPHALL' && prod.subOrderStatus === 'PF' && (['OVERDUE', 'USED'].indexOf(prod.orderStatus) > -1)) {
          return true
        } else {
          return false
        }
      })

      return this.productCountNoIti['PF'] <= hallDisable.length
    }
  },
  components: {
  }
}
</script>

<style lang="less">
  .order-base-header {
    &.aclry-base-header {
      color: @primary-color;
      padding-bottom: 5px;
      border-bottom: 1px solid #b7b7b7;
      margin-bottom: 0;
    }
  }

  .order-primary-header {
    &.aclry-primary-header {
      border-bottom: 0;
      margin-bottom: 0;

      .header-msg {
        display: inline-block;
        font-size: 14px;
        margin-left: -10px;
        padding: 10px 0;
      }

    }
  }

  .order-gray-table-outer {
    &.aclry-table-outer {
      background: #fff;
      padding: 10px 0;
    }
  }

  .base-info {
    margin-top: 50px;
  }

  .pass-info {
    margin-top: 50px;

    .pass-item {
      & + .pass-item {
        margin-top: 30px;
      }
    }
  }

  .ext-order-table {

    &.order-default-table tbody tr td {
      padding: 14px 10px;
    }

    &.order-default-table tbody tr td:first-child {
      padding-left: 18px;
    }

    .seg-line {
      position: relative;
    }

    .seg-tip {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      color: #fff;
      text-decoration: none;

      span {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        font-style: normal;
        margin: 3px;
        font-size: 10px;
      }

      &:before {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-top: 30px solid red;
        border-right: 30px solid transparent;
      }

      &.seg-old {
        &:before {
          border-top: 30px solid #808080;
        }
      }
    }
  }

  .change-notice {
    margin-top: 16px;
  }

  /*订单弹窗样式*/
  .order-modal {
    .ant-modal-title {
      margin: 0;
      font-size: 18px;
      line-height: 22px;
      font-weight: bold;
      color: #fff;
    }
    .ant-modal-content {
      position: relative;
      background-color: #fff;
      border: 0;
      border-radius: 0;
      background-clip: padding-box;
    }
    .ant-modal-header {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 16px 24px;
      border-radius: 0;
      background: @primary-color;
      color: #fff;
    }
    .ant-modal-body {
      padding: 24px;
      font-size: 12px;
      line-height: 1.5;
      word-wrap: break-word;
    }
    .ant-modal-footer {
      border-top: 0;
      padding: 0 16px 40px;
      text-align: center;
      border-radius: 0;
    }

    &.pay-modal {
      .ant-modal-body {
        padding: 0;
      }

      .ant-modal-footer {
        border-top: 0;
        padding: 16px;
        text-align: right;
        border-radius: 0;
        background: #f5f5f5;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .ext-order-table-warp {
      overflow-x: scroll;
    }
  }

</style>
